var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Cascader',{staticClass:"city-option",class:_vm.extraClass,attrs:{"data":_vm.cityOptions,"clearable":"","disabled":_vm.disabled,"placeholder":_vm.placeholder,"render-format":_vm.formatCity},on:{"on-change":_vm.cityChange},model:{value:(_vm.curCity),callback:function ($$v) {_vm.curCity=$$v},expression:"curCity"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }